import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { ParkingProcessListItemDto } from '../../../../../api/gen';
import { ParkingZoneParkingProcessItemComponent } from '../parking-zone-parking-process-item/parking-zone-parking-process-item.component';
import { ResponsiveBaseComponent } from 'shared-lib';

@Component({
  selector: 'app-parking-zone-parking-process-list',
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatPaginatorModule,
    ParkingZoneParkingProcessItemComponent
  ],
  templateUrl: './parking-zone-parking-process-list.component.html',
  styleUrl: './parking-zone-parking-process-list.component.scss'
})
export class ParkingZoneParkingProcessListComponent extends ResponsiveBaseComponent {
  @Input() processes: ParkingProcessListItemDto[] = [];
  @Input() isLoading: boolean = false;

  @Output() processSelected = new EventEmitter<ParkingProcessListItemDto>();
  @Output() pageChange = new EventEmitter<PageEvent>();

  // Pagination
  pageSize = 10;
  pageIndex = 0;

  get paginatedProcesses(): ParkingProcessListItemDto[] {
    const start = this.pageIndex * this.pageSize;
    const end = start + this.pageSize;
    return this.processes.slice(start, end);
  }

  onProcessClick(process: ParkingProcessListItemDto): void {
    this.processSelected.emit(process);
  }

  onPageChange(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.pageChange.emit(event);
  }
}
